'use client';

import Script from 'next/script';

import { trackingManager } from '@services/tracking';

export function TrackingScript() {
    return (
        <Script
            strategy='afterInteractive'
            src='https://www.stats.bouyguestelecom.fr/js/rainbow/tc_BouyguesTelecomAnalytics.js'
            type='text/javascript'
            onReady={() => void trackingManager.setup()}
        />
    );
}
